import { GoogleMapsInput } from 'client/components/Form/GoogleMapsInput';
import FormSelect from 'client/components/Form/FormSelect';
import Input from 'client/components/Form/Input';
import { styledSelect } from 'client/components/Form/Select/MenuListArrow';
import VideoCardFormFragment from 'client/components/VideoCardFormFragment';
import Validators from 'client/helpers/formValidator';

import React from 'react';
import { SelectComponents } from 'react-select/src/components';
import { ISelectorOption } from 'types/ISelectorOption';
import { useVideoDetails } from './useVideoDetails';

const component = styledSelect.components as Partial<
  SelectComponents<ISelectorOption, boolean>
>;

const VideoDetails = () => {
  const { t, parcourTypeOptions, videoTypeOptions } = useVideoDetails();

  return (
    <div className="container-fluid col-lg-6 col-sm-12 pl-md-6 pr-sm-0">
      <VideoCardFormFragment name="tags" title={t('addVideoDashboard.tags')} isText isAddCard>
        <Input
          name="tags"
          placeholder={t('addVideoDashboard.tags')}
          isVideo
          validate={Validators([{ validation: 'tags' }])}
        />
      </VideoCardFormFragment>
      <VideoCardFormFragment
        name="name"
        title={t('addVideoDashboard.videoName')}
        isText
        isAddCard
      >
        <Input
          name="name"
          placeholder={t('addVideoDashboard.name')}
          isVideo
          validate={Validators([{ validation: 'required' }])}
        />
      </VideoCardFormFragment>

      <VideoCardFormFragment
        name="countryCity"
        title={t('addVideoDashboard.countryAndCity')}
        isText
        isAddCard
      >
        <GoogleMapsInput
          validate={Validators([{ validation: 'required' }, { validation: 'validLocation' }])}
          name="countryCity"
        />
      </VideoCardFormFragment>

      <VideoCardFormFragment
        name="description"
        title={t('addVideoDashboard.description')}
        isText
        isAddCard
      >
        <Input
          name="description"
          placeholder={t('misc.description')}
          isVideo
          validate={Validators([{ validation: 'required' }])}
        />
      </VideoCardFormFragment>
      <VideoCardFormFragment
        name="parcourType"
        title={t('addVideoDashboard.parcourType')}
        isAddCard
      >
        <FormSelect
          defaultValue={parcourTypeOptions[0]}
          name="parcourType"
          components={component}
          variant="form"
          options={parcourTypeOptions}
          validate={Validators([{ validation: 'required' }])}
        />
      </VideoCardFormFragment>
      <VideoCardFormFragment
        name="videoType"
        title={t('addVideoDashboard.videoType')}
        isAddCard
      >
        <FormSelect
          defaultValue={videoTypeOptions[0]}
          name="videoType"
          components={component}
          variant="form"
          options={videoTypeOptions}
          validate={Validators([{ validation: 'required' }])}
        />
      </VideoCardFormFragment>
      <VideoCardFormFragment
        name="economy"
        title={t('addVideoDashboard.economy')}
        isText
        isAddCard
      >
        <Input
          name="economy"
          placeholder={t('addVideoDashboard.economyPlaceholder')}
          isVideo
        />
      </VideoCardFormFragment>
      <div className="row justify-content-center">
        <button
          type="submit"
          className="section-button alt-primary mt-2 pt-0 video-publish-button text-oxygen "
          style={{ zIndex: 0 }}
        >
          {t('addVideoDashboard.publish')}
        </button>
      </div>
    </div>
  );
};

export default VideoDetails;
